/*
    Wrapper over default angular dateFilter that adds timezone handling.
    Timezone provided as 3rd parameter to filter will override currently selected timezone.
*/
baseApp.config(['$provide', function($provide) {
    $provide.decorator('dateFilter', ['$delegate', 'TimeZoneService', function($delegate, TimeZoneService) {
        var oldDelegate = $delegate;

        var dateFilterInterceptor = function (date, format, timezone) {
            if(angular.isUndefined(timezone)) {
                timezone = TimeZoneService.getCurrentTimeZoneOffset();
            }
            return oldDelegate.apply(this, [date, format, timezone]);
        };

        return dateFilterInterceptor;
    }]);
}]);
